import styled from 'styled-components';
import { TableCell } from '@mui/material';

export const StyledTableCell = styled(TableCell)({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '10px'
});
